import { AxiosInstance } from 'axios';
import themeVariables from '@mais-retorno-front/theme/theme-variables';
import { IChartSeries } from '@mais-retorno-front/models/chart-serie';

interface IResponse {
  nicename: string;
  yields: {
    ay: number;
    d: number;
  }[];
}

export class PublicTitleDealsYieldsUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(slug: string): Promise<IChartSeries[]> {
    try {
      const { data } = await this.http.get<IResponse>(
        `titulos-publicos/deals/yields/${slug}`
      );

      const averegeYield: IChartSeries = {
        data: data.yields.map((item) => [item.d, item.ay]),
        name: 'Taxa média de juros',
        color: themeVariables.colors.preOperational,
        type: 'line',
        id: `averegeYield-${slug}`,
      };

      return [averegeYield];
    } catch (error) {
      return null;
    }
  }
}
